import React from "react"
import tw from "twin.macro"
import DownArrow from "../svgs/downArrow"
import AnimateWithBounce from "./animateWithBounce"

interface Props {
  label?: String
  onClick?: () => void
}

const NextPageButton: React.SFC<Props> = ({ label, onClick }) => (
  <button
    css={[
      tw`flex flex-col justify-center items-center focus:outline-none border-none`,
    ]}
    onClick={onClick}
  >
    {!!label && <span css={[tw`uppercase font-sans text-xs mb-2 tracking-wide`]}>
      {label}
    </span>}
    <AnimateWithBounce>
      <DownArrow css={[tw`text-white`]} />
    </AnimateWithBounce>
  </button>
)

export default NextPageButton